const development = (process.env.REACT_APP_DEVELOPMENT_MODE || process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV) === "development";
const root = String(process.env.REACT_APP_MATTERS_API_URL || (development ? "http://localhost:11303" : "https://api.matters3.feradel.com")).replace(/\/+$/, "");
const baseUrl = `${root}/api/v1/matters/setup/custom-domains`;
export const customDomainsUiEnabled = /^(1|true|yes|on)$/i.test(String(process.env.REACT_APP_CUSTOM_DOMAINS_ENABLED || ""));

const headers = (instanceId, idempotencyKey, json = false) => ({
  ...(json ? { "Content-Type": "application/json" } : {}),
  ...(localStorage.token ? { "x-auth-token": localStorage.token } : {}),
  instance: instanceId,
  ...(idempotencyKey ? { "idempotency-key": idempotencyKey } : {}),
});

async function request(path, { method = "GET", instanceId, idempotencyKey, body } = {}) {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), Number(process.env.REACT_APP_CUSTOM_DOMAIN_TIMEOUT_MS || 300000));
  try {
    const response = await fetch(`${baseUrl}${path}`, {
      method,
      headers: headers(instanceId, idempotencyKey, body !== undefined),
      ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
      credentials: "omit",
      signal: controller.signal,
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) return { success: false, ...data, error: data.error || { message: "The custom-domain request failed." } };
    return data;
  } finally {
    window.clearTimeout(timeout);
  }
}

const guarded = async (operation, fallback) => {
  try { return await operation(); }
  catch (_error) { return { success: false, error: { message: fallback } }; }
};

export const loadCustomDomains = async instanceId => {
  return guarded(() => request("/", { instanceId }), "Custom domains could not be loaded.");
};

export const verifyCustomDomain = async (instanceId, target, hostname) => {
  return guarded(() => request("/verify", { method: "POST", instanceId, body: { target, hostname } }), "DNS could not be verified.");
};

export const connectCustomDomain = async (instanceId, target, hostname, idempotencyKey) => {
  return guarded(() => request("/", { method: "POST", instanceId, idempotencyKey, body: { target, hostname } }), "The custom domain could not be connected.");
};

export const removeCustomDomain = async (instanceId, domainId, idempotencyKey) => {
  return guarded(() => request(`/${encodeURIComponent(domainId)}`, { method: "DELETE", instanceId, idempotencyKey }), "The custom domain could not be removed.");
};
